import {FC} from 'react'
import {MultiTagFilteringFieldRow} from 'components/SearchForm/MultiTagFilteringFieldRow'
import {withNull} from 'libs/options'

const workingStudentTypes = [
  {id: 'none', name: '対象外'},
  {id: 'working_student', name: '勤労学生'},
]

export const WorkingStudentTypes: FC = () => {
  return (
    <MultiTagFilteringFieldRow
      header="勤労学生区分"
      name="workingStudentTypes"
      list={withNull(workingStudentTypes)}
      shouldUnregister
    />
  )
}
